// Main JavaScript file for Alpina Insure to Study theme
(function () {
  "use strict";

  // [DISABLED] Chat functionality — will be replaced with a different solution
  // const WEBCHAT = (() => {
  //   let cmLoaded = false;
  //   let cmOpen = false;
  //   let shouldOpenAfterLoad = false;
  //   const cmWidgetId = "33da9a7f-f044-4f3e-a1ea-f2055cd1c45d"; // Widget ID from loaded script
  //
  //   function waitForWidgetReady(retry = 0) {
  //     const instance = cmwc?.get?.(cmWidgetId);
  //
  //     if (instance && typeof instance.open === "function") {
  //       cmLoaded = true;
  //
  //       if (shouldOpenAfterLoad) {
  //         instance.open();
  //         cmOpen = true;
  //         shouldOpenAfterLoad = false;
  //       }
  //     } else {
  //       if (retry > 50) {
  //         console.warn("Webchat widget not ready after maximum retries");
  //         return;
  //       }
  //       setTimeout(() => waitForWidgetReady(retry + 1), 100); // Try again in 100ms
  //     }
  //   }
  //
  //   function bindChatButtons() {
  //     const chatButtons = document.querySelectorAll(".c-chat-button");
  //
  //     if (chatButtons.length === 0) return;
  //
  //     chatButtons.forEach((btn) => {
  //       btn.addEventListener("click", (e) => {
  //         e.preventDefault();
  //
  //         if (!cmLoaded) {
  //           shouldOpenAfterLoad = true;
  //           waitForWidgetReady();
  //         } else {
  //           const instance = cmwc.get(cmWidgetId);
  //           if (cmOpen) {
  //             instance.close();
  //             cmOpen = false;
  //           } else {
  //             instance.open();
  //             cmOpen = true;
  //           }
  //         }
  //       });
  //     });
  //   }
  //
  //   function init() {
  //     // Wait for the webchat script to be available
  //     if (typeof cmwc !== "undefined") {
  //       bindChatButtons();
  //       waitForWidgetReady();
  //     } else {
  //       // If cmwc is not yet available, wait for it
  //       const checkInterval = setInterval(() => {
  //         if (typeof cmwc !== "undefined") {
  //           clearInterval(checkInterval);
  //           bindChatButtons();
  //           waitForWidgetReady();
  //         }
  //       }, 100);
  //     }
  //   }
  //
  //   return {
  //     init,
  //   };
  // })();

  // DOM ready function
  function ready(fn) {
    if (document.readyState !== "loading") {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }

  // Initialize theme functionality
  function init() {
    // [DISABLED] Chat functionality — will be replaced with a different solution
    // WEBCHAT.init();
  }

  // Run initialization when DOM is ready
  ready(init);
})();
